// src/models/notificationModel.js
import { messaging } from '../firebase';
import { getToken, deleteToken, onMessage, isSupported } from 'firebase/messaging';

export async function requestNotificationPermission(vapidKey) {
  // Optionally guard for unsupported browsers (e.g., Safari versions)
  const supported = await isSupported().catch(() => false);
  if (!supported) {
    throw new Error('Notifications are not supported by this browser');
  }

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    throw new Error('Notification permission denied');
  }

  // Ensure we have an active Service Worker registration
  const swReg = await navigator.serviceWorker.ready;
  const token = await getToken(messaging, {
    vapidKey,
    serviceWorkerRegistration: swReg,
  });
  return token;
}

export function subscribeToMessages(callback) {
  return onMessage(messaging, callback);
}

// Delete the current FCM token (best-effort) and request a fresh one
export async function resetFcmToken(vapidKey) {
  const supported = await isSupported().catch(() => false);
  if (!supported) {
    throw new Error('Notifications are not supported by this browser');
  }
  const swReg = await navigator.serviceWorker.ready;
  try {
    await deleteToken(messaging);
  } catch (_) {
    // ignore
  }
  const newToken = await getToken(messaging, {
    vapidKey,
    serviceWorkerRegistration: swReg,
  });
  return newToken;
}
